// import React, { useState, useEffect, useCallback } from "react";
// import styled from "styled-components";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import NavaService from "../services/NavaService";

// const showAdminAlert = (text, icon = "info") => Swal.fire({
//   text,
//   icon,
//   confirmButtonColor: "#5d191a",
// });

// const confirmAdminAction = (text) => Swal.fire({
//   text,
//   icon: "warning",
//   showCancelButton: true,
//   confirmButtonText: "Confirm",
//   confirmButtonColor: "#5d191a",
//   cancelButtonColor: "#707070",
// });

// const TABS = [
//   { key: "messages", label: "Messages" },
//   { key: "properties", label: "Properties" },
//   { key: "counties", label: "Counties" },
// ];

// export default function AdminDashboard() {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("messages");
//   const [admin, setAdmin] = useState(null);

//   useEffect(() => {
//     const raw = localStorage.getItem("user");
//     if (!raw) {
//       navigate("/admin/login", { state: { from: "/admin" }, replace: true });
//       return;
//     }
//     try {
//       setAdmin(JSON.parse(raw));
//     } catch (e) {
//       navigate("/admin/login", { state: { from: "/admin" }, replace: true });
//     }
//   }, [navigate]);

//   const handleLogout = () => {
//     NavaService.logout();
//     navigate("/admin/login", { replace: true });
//   };

//   if (!admin) return null;

//   return (
//     <Page>
//       <TopBar className="flexSpaceCenter">
//         <div className="flexNullCenter">
//           <img src="/sare-logo.png" alt="Sare Auctioneers logo" style={{ width: 56, height: 36, objectFit: "contain", marginRight: 10 }} />
//           <div>
//             <TitleText>Sare Auctioneers Admin</TitleText>
//             <SubText>Signed in as {admin.username}</SubText>
//           </div>
//         </div>
//         <LogoutBtn onClick={handleLogout} className="pointer animate radius8">Log out</LogoutBtn>
//       </TopBar>

//       <TabBar>
//         {TABS.map((t) => (
//           <TabButton key={t.key} active={activeTab === t.key} onClick={() => setActiveTab(t.key)}>
//             {t.label}
//           </TabButton>
//         ))}
//       </TabBar>

//       <Content>
//         {activeTab === "messages" && <MessagesTab />}
//         {activeTab === "properties" && <PropertiesTab />}
//         {activeTab === "counties" && <CountiesTab />}
//       </Content>
//     </Page>
//   );
// }

// /* ============================= MESSAGES ============================= */

// function MessagesTab() {
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await NavaService.getMessages();
//       setMessages(res.data || []);
//     } catch (err) {
//       setError("Failed to load messages.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { load(); }, [load]);

//   const handleMarkRead = async (id) => {
//     try {
//       await NavaService.markMessageRead(id);
//       setMessages((prev) => prev.map((m) => (m.id === id ? { ...m, is_read: 1 } : m)));
//     } catch (err) {
//       showAdminAlert("Could not update the message.", "error");
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirm = await confirmAdminAction("Delete this message?");
//     if (!confirm.isConfirmed) return;
//     try {
//       await NavaService.deleteMessage(id);
//       setMessages((prev) => prev.filter((m) => m.id !== id));
//       showAdminAlert("Message deleted.", "success");
//     } catch (err) {
//       showAdminAlert("Could not delete the message.", "error");
//     }
//   };

//   if (loading) return <EmptyState>Loading messages...</EmptyState>;
//   if (error) return <EmptyState>{error}</EmptyState>;
//   if (messages.length === 0) return <EmptyState>No client messages yet.</EmptyState>;

//   return (
//     <MessageList>
//       {messages.map((m) => (
//         <MessageCard key={m.id} unread={!m.is_read}>
//           <MessageHeader className="flexSpaceCenter">
//             <div>
//               <strong>{m.first_name}</strong>{" "}
//               <span className="font13" style={{ color: "#707070" }}>&lt;{m.email}&gt;</span>
//             </div>
//             <span className="font13" style={{ color: "#707070" }}>
//               {new Date(m.created_at).toLocaleString()}
//             </span>
//           </MessageHeader>
//           {m.subject && <MessageSubject>{m.subject}</MessageSubject>}
//           <MessageBody>{m.message}</MessageBody>
//           <MessageActions>
//             {!m.is_read && (
//               <SmallBtn onClick={() => handleMarkRead(m.id)} className="pointer">Mark read</SmallBtn>
//             )}
//             <SmallBtn danger onClick={() => handleDelete(m.id)} className="pointer">Delete</SmallBtn>
//           </MessageActions>
//         </MessageCard>
//       ))}
//     </MessageList>
//   );
// }

// /* ============================= COUNTIES ============================= */

// function CountiesTab() {
//   const [counties, setCounties] = useState([]);
//   const [newName, setNewName] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [saving, setSaving] = useState(false);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await NavaService.getCounties();
//       setCounties(res.data || []);
//     } catch (err) {
//       setError("Failed to load counties.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { load(); }, [load]);

//   const handleAdd = async (e) => {
//     e.preventDefault();
//     const name = newName.trim();
//     if (!name) return;
//     setSaving(true);
//     try {
//       const res = await NavaService.addCounty(name);
//       setCounties((prev) => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
//       setNewName("");
//       showAdminAlert("County added.", "success");
//     } catch (err) {
//       showAdminAlert(err?.response?.data?.message || "Could not add the county.", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirm = await confirmAdminAction("Remove this county?");
//     if (!confirm.isConfirmed) return;
//     try {
//       await NavaService.deleteCounty(id);
//       setCounties((prev) => prev.filter((c) => c.id !== id));
//       showAdminAlert("County removed.", "success");
//     } catch (err) {
//       showAdminAlert(err?.response?.data?.message || "Could not remove the county.", "error");
//     }
//   };

//   return (
//     <div>
//       <InlineForm onSubmit={handleAdd}>
//         <input
//           type="text"
//           placeholder="New county name"
//           value={newName}
//           onChange={(e) => setNewName(e.target.value)}
//         />
//         <SmallBtn as="button" type="submit" disabled={saving} className="pointer">
//           {saving ? "Adding..." : "Add county"}
//         </SmallBtn>
//       </InlineForm>

//       {loading ? (
//         <EmptyState>Loading counties...</EmptyState>
//       ) : error ? (
//         <EmptyState>{error}</EmptyState>
//       ) : counties.length === 0 ? (
//         <EmptyState>No counties yet. Add one above.</EmptyState>
//       ) : (
//         <TableScroll>
//           <Table>
//             <thead>
//               <tr><th>Name</th><th style={{ width: 100 }}></th></tr>
//             </thead>
//             <tbody>
//               {counties.map((c) => (
//                 <tr key={c.id}>
//                   <td>{c.name}</td>
//                   <td>
//                     <SmallBtn danger onClick={() => handleDelete(c.id)} className="pointer">Remove</SmallBtn>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </TableScroll>
//       )}
//     </div>
//   );
// }

// /* ============================= PROPERTIES ============================= */

// const EMPTY_PROPERTY = {
//   id: null,
//   county_id: "",
//   title_number: "",
//   location: "",
//   tenure: "",
//   approximate_area: "",
//   proprietor: "",
//   market_value: "",
//   forced_sale_value: "",
//   situation: "",
//   latitude: "",
//   longitude: "",
//   coordinates_text: "",
//   description: "",
//   improvements: "",
//   services: "",
//   status: "available",
//   user:"",
// };

// function PropertiesTab() {
//   const [properties, setProperties] = useState([]);
//   const [counties, setCounties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [form, setForm] = useState(EMPTY_PROPERTY);
//   const [saving, setSaving] = useState(false);
//   const [files, setFiles] = useState([]);
//   const [existingImages, setExistingImages] = useState([]);
//   const [pendingImages, setPendingImages] = useState([]);
//   const [imagesLoading, setImagesLoading] = useState(false);
//   const [importing, setImporting] = useState(false);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const [propRes, countyRes] = await Promise.all([
//         NavaService.getProperties({ status: "" }), // empty status = admin sees everything server allows; falls back to open listings
//         NavaService.getCounties(),
//       ]);
//       setProperties(propRes.data?.data || []);
//       setCounties(countyRes.data || []);
//     } catch (err) {
//       setError("Failed to load properties.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { load(); }, [load]);

//   const startNew = () => {
//     setForm(EMPTY_PROPERTY);
//     setFiles([]);
//     setPendingImages([]);
//     setExistingImages([]);
//     setShowForm(true);
//   };

//   const startEdit = async (p) => {
//     setForm({
//       id: p.id,
//       county_id: p.county_id ?? "",
//       title_number: p.title_number ?? "",
//       location: p.location ?? "",
//       tenure: p.tenure ?? "",
//       approximate_area: p.approximate_area ?? "",
//       user: p.user ?? "",
//       proprietor: p.proprietor ?? "",
//       market_value: p.market_value ?? "",
//       forced_sale_value: p.forced_sale_value ?? "",
//       situation: p.situation ?? "",
//       latitude: p.latitude ?? "",
//       longitude: p.longitude ?? "",
//       coordinates_text: p.coordinates_text ?? "",
//       description: p.description ?? "",
//       improvements: p.improvements ?? "",
//       services: p.services ?? "",
//       status: p.status ?? "available",
//     });
//     setFiles([]);
//     setPendingImages([]);
//     setShowForm(true);

//     // the list endpoint only returns a single cover_image, so fetch the
//     // full record to get every photo already attached to this property
//     setImagesLoading(true);
//     try {
//       const res = await NavaService.getPropertyById(p.id);
//       setExistingImages(res.data?.images || []);
//     } catch (err) {
//       setExistingImages([]);
//     } finally {
//       setImagesLoading(false);
//     }
//   };

//   const handleDeleteImage = async (imageId) => {
//     const confirm = await confirmAdminAction("Remove this photo?");
//     if (!confirm.isConfirmed) return;
//     try {
//       await NavaService.deletePropertyImage(form.id, imageId);
//       setExistingImages((prev) => prev.filter((img) => img.id !== imageId));
//       showAdminAlert("Photo removed.", "success");
//     } catch (err) {
//       showAdminAlert("Could not remove the photo.", "error");
//     }
//   };

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const handleItemImport = async (e, startNewImport = false) => {
//     const filesToImport = Array.from(e.target.files || []);
//     e.target.value = "";
//     if (filesToImport.length === 0) return;

//     setImporting(true);
//     try {
//       const res = await NavaService.importPropertyItem(filesToImport);
//       const imported = res.data?.fields || {};
//       const importedImages = await Promise.all((res.data?.images || []).map(async (image, index) => {
//         const blob = await fetch(`data:${image.type};base64,${image.data}`).then((response) => response.blob());
//         return new File([blob], image.name || `item-image-${index + 1}`, { type: image.type });
//       }));
//       setForm((current) => ({
//         ...(startNewImport ? EMPTY_PROPERTY : current),
//         ...imported,
//         id: startNewImport ? null : current.id,
//       }));
//       setFiles(importedImages);
//       setPendingImages(importedImages.map((file) => ({ file, url: URL.createObjectURL(file) })));
//       setExistingImages([]);
//       setShowForm(true);
//       showAdminAlert(
//         res.data?.countyMatched
//           ? "Property details imported. Review the fields before saving."
//           : "Property details imported. County could not be matched, so select it before saving.",
//         res.data?.countyMatched ? "success" : "warning"
//       );
//     } catch (err) {
//       showAdminAlert(err?.response?.data?.message || "Could not import this file.", "error");
//     } finally {
//       setImporting(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.county_id || !form.title_number.trim() || !form.location.trim()) {
//       showAdminAlert("County, title number and location are required.", "warning");
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = { ...form };
//       delete payload.id;

//       let propertyId = form.id;
//       if (form.id) {
//         await NavaService.updateProperty(form.id, payload);
//       } else {
//         const res = await NavaService.createProperty(payload);
//         propertyId = res.data.id;
//       }

//       for (const file of files) {
//         await NavaService.uploadPropertyImage(propertyId, file);
//       }

//       setShowForm(false);
//       setFiles([]);
//       setPendingImages([]);
//       setExistingImages([]);
//       load();
//     } catch (err) {
//       showAdminAlert(err?.response?.data?.message || "Could not save the property.", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirm = await confirmAdminAction("Delete this property and its photos?");
//     if (!confirm.isConfirmed) return;
//     try {
//       await NavaService.deleteProperty(id);
//       setProperties((prev) => prev.filter((p) => p.id !== id));
//       showAdminAlert("Property deleted.", "success");
//     } catch (err) {
//       showAdminAlert("Could not delete the property.", "error");
//     }
//   };

//   return (
//     <div>
//       <ActionsRow className="flexSpaceCenter">
//         <span className="font13" style={{ color: "#707070" }}>{properties.length} listing(s)</span>
//         <DashboardActions>
//           <SmallBtn onClick={startNew} className="pointer">+ Add property</SmallBtn>
//           <label>
//             <SmallBtn as="span" primary className="pointer">Upload property file</SmallBtn>
//             <input
//               type="file"
//               accept=".docx,.txt,image/*,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//               multiple
//               onChange={(e) => handleItemImport(e, true)}
//               disabled={importing}
//               hidden
//             />
//           </label>
//         </DashboardActions>
//       </ActionsRow>

//       {showForm && (
//         <FormCard>
//           <ImportPanel>
//             <div>
//               <strong>Import property details</strong>
//               <p>Upload a DOCX or text item file to fill the form. Review the extracted values before saving.</p>
//             </div>
//             <label className="pointer">
//               <SmallBtn as="span" primary>{importing ? "Reading..." : "Upload item file"}</SmallBtn>
//               <input type="file" accept=".docx,.txt,image/*,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple onChange={(e) => handleItemImport(e)} disabled={importing} hidden />
//             </label>
//           </ImportPanel>
//           <Form onSubmit={handleSubmit}>
//             <FormGrid>
//               <Field>
//                 <label className="font13">County *</label>
//                 <select name="county_id" value={form.county_id} onChange={handleChange}>
//                   <option value="">Select county</option>
//                   {counties.map((c) => (
//                     <option key={c.id} value={c.id}>{c.name}</option>
//                   ))}
//                 </select>
//               </Field>

//               <Field>
//                 <label className="font13">Status</label>
//                 <select name="status" value={form.status} onChange={handleChange}>
//                   <option value="available">Available</option>
//                   <option value="under_auction">Under auction</option>
//                   <option value="sold">Sold</option>
//                   <option value="withdrawn">Withdrawn</option>
//                 </select>
//               </Field>

//               <Field><label className="font13">Title number *</label><input name="title_number" value={form.title_number} onChange={handleChange} /></Field>
//               <Field><label className="font13">Location *</label><input name="location" value={form.location} onChange={handleChange} /></Field>
//               <Field><label className="font13">Tenure</label><input name="tenure" value={form.tenure} onChange={handleChange} placeholder="Freehold / Leasehold" /></Field>
//               <Field><label className="font13">Approximate area</label><input name="approximate_area" value={form.approximate_area} onChange={handleChange} placeholder="e.g. 0.25 Ha" /></Field>
//               <Field><label className="font13">User</label><input name="user" value={form.user} onChange={handleChange} /></Field>
//               {/* <Field><label className="font13">Market value (KES)</label><input type="number" name="market_value" value={form.market_value} onChange={handleChange} /></Field>
//               <Field><label className="font13">Forced sale value (KES)</label><input type="number" name="forced_sale_value" value={form.forced_sale_value} onChange={handleChange} /></Field> */}
//               <Field><label className="font13">Latitude</label><input name="latitude" value={form.latitude} onChange={handleChange} /></Field>
//               <Field><label className="font13">Longitude</label><input name="longitude" value={form.longitude} onChange={handleChange} /></Field>
//               <Field><label className="font13">Coordinates (as surveyed)</label><input name="coordinates_text" value={form.coordinates_text} onChange={handleChange} /></Field>
//             </FormGrid>

//             <Field full><label className="font13">Situation</label><textarea rows="2" name="situation" value={form.situation} onChange={handleChange} /></Field>
//             <Field full><label className="font13">Description</label><textarea rows="3" name="description" value={form.description} onChange={handleChange} /></Field>
//             <Field full><label className="font13">Improvements</label><textarea rows="2" name="improvements" value={form.improvements} onChange={handleChange} /></Field>
//             <Field full><label className="font13">Services</label><textarea rows="2" name="services" value={form.services} onChange={handleChange} placeholder="Water, electricity, road access..." /></Field>

//             {form.id && (
//               <Field full>
//                 <label className="font13">Current photos</label>
//                 {imagesLoading ? (
//                   <span className="font13" style={{ color: "#707070" }}>Loading photos...</span>
//                 ) : existingImages.length === 0 ? (
//                   <span className="font13" style={{ color: "#707070" }}>No photos uploaded yet.</span>
//                 ) : (
//                   <ImageGrid>
//                     {existingImages.map((img) => (
//                       <ImageThumbWrap key={img.id}>
//                         <img src={NavaService.getPropertyImageUrl(form.id, img.file_name)} alt="" />
//                         <RemoveImageBtn type="button" onClick={() => handleDeleteImage(img.id)} title="Remove photo">×</RemoveImageBtn>
//                       </ImageThumbWrap>
//                     ))}
//                   </ImageGrid>
//                 )}
//               </Field>
//             )}

//             {pendingImages.length > 0 && (
//               <Field full>
//                 <label className="font13">Images to save</label>
//                 <PendingImageGrid>
//                   {pendingImages.map((image, index) => (
//                     <PendingImageWrap key={`${image.file.name}-${index}`}>
//                       <img src={image.url} alt={image.file.name} />
//                       <RemoveImageBtn
//                         type="button"
//                         onClick={() => {
//                           setFiles((current) => current.filter((file) => file !== image.file));
//                           setPendingImages((current) => current.filter((item) => item.file !== image.file));
//                           URL.revokeObjectURL(image.url);
//                         }}
//                         title="Remove image before saving"
//                       >
//                         ×
//                       </RemoveImageBtn>
//                     </PendingImageWrap>
//                   ))}
//                 </PendingImageGrid>
//               </Field>
//             )}

//             <Field full>
//               <label className="font13">{form.id ? "Add more photos" : "Add photos"}</label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 multiple
//                 onChange={(e) => {
//                   const selected = Array.from(e.target.files || []);
//                   setFiles((current) => [...current, ...selected]);
//                   setPendingImages((current) => [
//                     ...current,
//                     ...selected.map((file) => ({ file, url: URL.createObjectURL(file) })),
//                   ]);
//                   e.target.value = "";
//                 }}
//               />
//             </Field>

//             <FormActions>
//               <SmallBtn type="button" onClick={() => setShowForm(false)} className="pointer">Cancel</SmallBtn>
//               <SmallBtn type="submit" disabled={saving} className="pointer" primary>
//                 {saving ? "Saving..." : "Save property"}
//               </SmallBtn>
//             </FormActions>
//           </Form>
//         </FormCard>
//       )}

//       {loading ? (
//         <EmptyState>Loading properties...</EmptyState>
//       ) : error ? (
//         <EmptyState>{error}</EmptyState>
//       ) : properties.length === 0 ? (
//         <EmptyState>No properties yet. Add one above.</EmptyState>
//       ) : (
//         <TableScroll>
//           <Table>
//             <thead>
//               <tr>
//                 <th>Title number</th><th>Location</th><th>County</th><th>Status</th><th style={{ width: 140 }}></th>
//               </tr>
//             </thead>
//             <tbody>
//               {properties.map((p) => (
//                 <tr key={p.id}>
//                   <td>{p.title_number}</td>
//                   <td>{p.location}</td>
//                   <td>{p.county_name}</td>
//                   <td><StatusPill status={p.status}>{p.status.replace("_", " ")}</StatusPill></td>
//                   <td style={{ whiteSpace: "nowrap" }}>
//                     <SmallBtn onClick={() => startEdit(p)} className="pointer">Edit</SmallBtn>{" "}
//                     <SmallBtn danger onClick={() => handleDelete(p.id)} className="pointer">Delete</SmallBtn>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </TableScroll>
//       )}
//     </div>
//   );
// }

// /* ============================= styles ============================= */

// const Page = styled.div`
//   min-height: 100vh;
//   background: #f5f7fb;
//   padding-bottom: 60px;
// `;

// const TopBar = styled.div`
//   background: #ffffff;
//   padding: 16px 30px;
//   border-bottom: 1px solid #e6eaf0;
// `;

// const TitleText = styled.div`
//   font-weight: 800;
//   color: #13365c;
//   font-size: 16px;
// `;

// const SubText = styled.div`
//   font-size: 12px;
//   color: #707070;
// `;

// const LogoutBtn = styled.button`
//   border: 1px solid #d8dee8;
//   background: transparent;
//   padding: 8px 16px;
//   font-weight: 700;
//   color: #13365c;
//   &:hover { background: #f0f2f6; }
// `;

// const TabBar = styled.div`
//   display: flex;
//   gap: 4px;
//   padding: 20px 30px 0;
// `;

// const TabButton = styled.button`
//   padding: 10px 18px;
//   border: 0;
//   background: ${(p) => (p.active ? "#ffffff" : "transparent")};
//   color: ${(p) => (p.active ? "#5d191a" : "#13365c")};
//   font-weight: 700;
//   border-radius: 8px 8px 0 0;
//   cursor: pointer;
//   border-bottom: 3px solid ${(p) => (p.active ? "#5d191a" : "transparent")};
// `;

// const Content = styled.div`
//   background: #ffffff;
//   margin: 0 30px;
//   padding: 24px;
//   border-radius: 0 8px 8px 8px;
//   box-shadow: 0 4px 20px rgba(19, 54, 92, 0.06);

//   @media (max-width: 640px) {
//     margin: 0 12px;
//     padding: 16px;
//   }
// `;

// const EmptyState = styled.div`
//   padding: 40px 0;
//   text-align: center;
//   color: #707070;
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 14px;

//   th {
//     text-align: left;
//     padding: 10px 12px;
//     color: #707070;
//     font-size: 12px;
//     text-transform: uppercase;
//     border-bottom: 2px solid #eef1f6;
//   }
//   td {
//     padding: 12px;
//     border-bottom: 1px solid #eef1f6;
//     color: #13365c;
//   }
//   tr:hover td { background: #fafbfd; }
// `;

// const StatusPill = styled.span`
//   display: inline-block;
//   padding: 3px 10px;
//   border-radius: 20px;
//   font-size: 12px;
//   font-weight: 700;
//   text-transform: capitalize;
//   background: ${(p) =>
//     p.status === "sold" ? "#fdecec" :
//       p.status === "withdrawn" ? "#f0f0f0" :
//         p.status === "under_auction" ? "#fff4e0" : "#e9f9ee"};
//   color: ${(p) =>
//     p.status === "sold" ? "#d63b3b" :
//       p.status === "withdrawn" ? "#707070" :
//         p.status === "under_auction" ? "#b76e00" : "#1a8f4c"};
// `;

// const MessageList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 14px;
// `;

// const MessageCard = styled.div`
//   border: 1px solid #eef1f6;
//   border-left: 4px solid ${(p) => (p.unread ? "#5d191a" : "#eef1f6")};
//   border-radius: 8px;
//   padding: 16px;
//   background: ${(p) => (p.unread ? "#faf7ff" : "#fff")};
// `;

// const MessageHeader = styled.div`
//   margin-bottom: 6px;
// `;

// const MessageSubject = styled.div`
//   font-weight: 700;
//   color: #13365c;
//   margin-bottom: 4px;
// `;

// const MessageBody = styled.p`
//   margin: 0 0 10px;
//   color: #333;
//   white-space: pre-wrap;
// `;

// const MessageActions = styled.div`
//   display: flex;
//   gap: 8px;
// `;

// const ActionsRow = styled.div`
//   margin-bottom: 18px;
// `;

// const InlineForm = styled.form`
//   display: flex;
//   gap: 10px;
//   margin-bottom: 20px;

//   input {
//     flex: 1;
//     max-width: 320px;
//     height: 38px;
//     border-radius: 8px;
//     border: 1px solid #d8dee8;
//     padding: 0 12px;
//     outline: none;
//   }
// `;

// const FormCard = styled.div`
//   border: 1px solid #eef1f6;
//   border-radius: 8px;
//   padding: 20px;
//   margin-bottom: 24px;
//   background: #fafbfd;
// `;

// const ImportPanel = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;
//   padding: 14px 16px;
//   margin-bottom: 20px;
//   border: 1px solid #eadfe0;
//   border-radius: 8px;
//   background: #fff8f8;

//   strong { color: #3b1718; }
//   p { margin: 4px 0 0; color: #6f4b4b; font-size: 13px; }

//   @media (max-width: 640px) {
//     align-items: stretch;
//     flex-direction: column;
//   }
// `;

// const DashboardActions = styled.div`
//   display: flex;
//   gap: 8px;
//   align-items: center;

//   label { display: inline-flex; }

//   @media (max-width: 560px) {
//     flex-direction: column;
//     align-items: stretch;
//   }
// `;

// const PendingImageGrid = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 4px;
// `;

// const PendingImageWrap = styled.div`
//   position: relative;
//   width: 120px;
//   height: 90px;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     display: block;
//     border: 1px solid #eadfe0;
//     border-radius: 6px;
//   }
// `;

// const Form = styled.form``;

// const FormGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 14px;

//   @media (max-width: 860px) {
//     grid-template-columns: repeat(2, 1fr);
//   }
//   @media (max-width: 560px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const Field = styled.div`
//   display: flex;
//   flex-direction: column;
//   margin-top: 14px;
//   ${(p) => p.full && "grid-column: 1 / -1;"}

//   label { margin-bottom: 6px; color: #13365c; font-weight: 700; }

//   input, select, textarea {
//     height: 38px;
//     border-radius: 8px;
//     border: 1px solid #d8dee8;
//     padding: 0 12px;
//     outline: none;
//     font-size: 14px;
//     background: #fff;
//   }
//   textarea {
//     height: auto;
//     padding: 10px 12px;
//     resize: vertical;
//   }
// `;

// const FormActions = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   gap: 10px;
//   margin-top: 20px;
// `;

// const ImageGrid = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 4px;
// `;

// const ImageThumbWrap = styled.div`
//   position: relative;
//   width: 90px;
//   height: 70px;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     border-radius: 6px;
//     display: block;
//     border: 1px solid #eef1f6;
//   }
// `;

// const RemoveImageBtn = styled.button`
//   position: absolute;
//   top: -6px;
//   right: -6px;
//   width: 20px;
//   height: 20px;
//   border-radius: 50%;
//   border: 0;
//   background: #d63b3b;
//   color: #fff;
//   font-size: 13px;
//   line-height: 1;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover { background: #b62e2e; }
// `;

// const SmallBtn = styled.button`
//   border: 1px solid ${(p) => (p.danger ? "#f3c8c8" : p.primary ? "#5d191a" : "#d8dee8")};
//   background: ${(p) => (p.danger ? "#fff5f5" : p.primary ? "#5d191a" : "#fff")};
//   color: ${(p) => (p.danger ? "#d63b3b" : p.primary ? "#fff" : "#13365c")};
//   padding: 7px 14px;
//   border-radius: 6px;
//   font-weight: 700;
//   font-size: 13px;
//   cursor: pointer;

//   &:disabled { opacity: 0.6; cursor: not-allowed; }
//   &:hover { filter: brightness(0.97); }
// `;

// const TableScroll = styled.div`
//   width: 100%;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
// `;
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import NavaService from "../services/NavaService";

const showAdminAlert = (text, icon = "info") => Swal.fire({
  text,
  icon,
  confirmButtonColor: "#5d191a",
});

const confirmAdminAction = (text) => Swal.fire({
  text,
  icon: "warning",
  showCancelButton: true,
  confirmButtonText: "Confirm",
  confirmButtonColor: "#5d191a",
  cancelButtonColor: "#707070",
});

const TABS = [
  { key: "messages", label: "Messages" },
  { key: "properties", label: "Properties" },
  { key: "counties", label: "Counties" },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("messages");
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (!raw) {
      navigate("/admin/login", { state: { from: "/admin" }, replace: true });
      return;
    }
    try {
      setAdmin(JSON.parse(raw));
    } catch (e) {
      navigate("/admin/login", { state: { from: "/admin" }, replace: true });
    }
  }, [navigate]);

  const handleLogout = () => {
    NavaService.logout();
    navigate("/admin/login", { replace: true });
  };

  if (!admin) return null;

  return (
    <Page>
      <TopBar className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img src="/sare-logo.png" alt="Sare Auctioneers logo" style={{ width: 56, height: 36, objectFit: "contain", marginRight: 10 }} />
          <div>
            <TitleText>Sare Auctioneers Admin</TitleText>
            <SubText>Signed in as {admin.username}</SubText>
          </div>
        </div>
        <LogoutBtn onClick={handleLogout} className="pointer animate radius8">Log out</LogoutBtn>
      </TopBar>

      <TabBar>
        {TABS.map((t) => (
          <TabButton key={t.key} active={activeTab === t.key} onClick={() => setActiveTab(t.key)}>
            {t.label}
          </TabButton>
        ))}
      </TabBar>

      <Content>
        {activeTab === "messages" && <MessagesTab />}
        {activeTab === "properties" && <PropertiesTab />}
        {activeTab === "counties" && <CountiesTab />}
      </Content>
    </Page>
  );
}

/* ============================= shared pagination ============================= */

function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <PaginationBar className="flexCenter">
      <PageBtn disabled={page <= 1} onClick={() => onChange(page - 1)} className="pointer">‹ Prev</PageBtn>
      <PageNumbers>
        {pages.map((p) => (
          <PageNumber key={p} type="button" active={p === page} onClick={() => onChange(p)} className="pointer">
            {p}
          </PageNumber>
        ))}
      </PageNumbers>
      <PageBtn disabled={page >= totalPages} onClick={() => onChange(page + 1)} className="pointer">Next ›</PageBtn>
    </PaginationBar>
  );
}

/* ============================= MESSAGES ============================= */

const MESSAGES_PAGE_SIZE = 6;

function MessagesTab() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await NavaService.getMessages();
      setMessages(res.data || []);
    } catch (err) {
      setError("Failed to load messages.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // reset to page 1 whenever the search term changes
  useEffect(() => { setPage(1); }, [search]);

  const handleMarkRead = async (id) => {
    try {
      await NavaService.markMessageRead(id);
      setMessages((prev) => prev.map((m) => (m.id === id ? { ...m, is_read: 1 } : m)));
    } catch (err) {
      showAdminAlert("Could not update the message.", "error");
    }
  };

  const handleDelete = async (id) => {
    const confirm = await confirmAdminAction("Delete this message?");
    if (!confirm.isConfirmed) return;
    try {
      await NavaService.deleteMessage(id);
      setMessages((prev) => prev.filter((m) => m.id !== id));
      showAdminAlert("Message deleted.", "success");
    } catch (err) {
      showAdminAlert("Could not delete the message.", "error");
    }
  };

  const filtered = messages.filter((m) => {
    const term = search.trim().toLowerCase();
    if (!term) return true;
    return (
      (m.first_name || "").toLowerCase().includes(term) ||
      (m.email || "").toLowerCase().includes(term) ||
      (m.subject || "").toLowerCase().includes(term)
    );
  });

  const totalPages = Math.max(1, Math.ceil(filtered.length / MESSAGES_PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * MESSAGES_PAGE_SIZE, page * MESSAGES_PAGE_SIZE);

  if (loading) return <EmptyState>Loading messages...</EmptyState>;
  if (error) return <EmptyState>{error}</EmptyState>;

  return (
    <div>
      <FilterBar>
        <SearchInput
          type="text"
          placeholder="Search by name, email, or subject..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <ResultCount className="font13">{filtered.length} message(s)</ResultCount>
      </FilterBar>

      {messages.length === 0 ? (
        <EmptyState>No client messages yet.</EmptyState>
      ) : filtered.length === 0 ? (
        <EmptyState>No messages match your search.</EmptyState>
      ) : (
        <>
          <MessageList>
            {pageItems.map((m) => (
              <MessageCard key={m.id} unread={!m.is_read}>
                <MessageHeader className="flexSpaceCenter">
                  <div>
                    <strong>{m.first_name}</strong>{" "}
                    <span className="font13" style={{ color: "#707070" }}>&lt;{m.email}&gt;</span>
                  </div>
                  <span className="font13" style={{ color: "#707070" }}>
                    {new Date(m.created_at).toLocaleString()}
                  </span>
                </MessageHeader>
                {m.subject && <MessageSubject>{m.subject}</MessageSubject>}
                <MessageBody>{m.message}</MessageBody>
                <MessageActions>
                  {!m.is_read && (
                    <SmallBtn onClick={() => handleMarkRead(m.id)} className="pointer">Mark read</SmallBtn>
                  )}
                  <SmallBtn danger onClick={() => handleDelete(m.id)} className="pointer">Delete</SmallBtn>
                </MessageActions>
              </MessageCard>
            ))}
          </MessageList>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}

/* ============================= COUNTIES ============================= */

const COUNTIES_PAGE_SIZE = 8;

function CountiesTab() {
  const [counties, setCounties] = useState([]);
  const [newName, setNewName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await NavaService.getCounties();
      setCounties(res.data || []);
    } catch (err) {
      setError("Failed to load counties.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [search]);

  const handleAdd = async (e) => {
    e.preventDefault();
    const name = newName.trim();
    if (!name) return;
    setSaving(true);
    try {
      const res = await NavaService.addCounty(name);
      setCounties((prev) => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
      setNewName("");
      showAdminAlert("County added.", "success");
    } catch (err) {
      showAdminAlert(err?.response?.data?.message || "Could not add the county.", "error");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await confirmAdminAction("Remove this county?");
    if (!confirm.isConfirmed) return;
    try {
      await NavaService.deleteCounty(id);
      setCounties((prev) => prev.filter((c) => c.id !== id));
      showAdminAlert("County removed.", "success");
    } catch (err) {
      showAdminAlert(err?.response?.data?.message || "Could not remove the county.", "error");
    }
  };

  const filtered = counties.filter((c) =>
    c.name.toLowerCase().includes(search.trim().toLowerCase())
  );

  const totalPages = Math.max(1, Math.ceil(filtered.length / COUNTIES_PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * COUNTIES_PAGE_SIZE, page * COUNTIES_PAGE_SIZE);

  return (
    <div>
      <InlineForm onSubmit={handleAdd}>
        <input
          type="text"
          placeholder="New county name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
        <SmallBtn as="button" type="submit" disabled={saving} className="pointer">
          {saving ? "Adding..." : "Add county"}
        </SmallBtn>
      </InlineForm>

      <FilterBar>
        <SearchInput
          type="text"
          placeholder="Search counties..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <ResultCount className="font13">{filtered.length} count{filtered.length === 1 ? "y" : "ies"}</ResultCount>
      </FilterBar>

      {loading ? (
        <EmptyState>Loading counties...</EmptyState>
      ) : error ? (
        <EmptyState>{error}</EmptyState>
      ) : counties.length === 0 ? (
        <EmptyState>No counties yet. Add one above.</EmptyState>
      ) : filtered.length === 0 ? (
        <EmptyState>No counties match your search.</EmptyState>
      ) : (
        <>
          <TableScroll>
            <Table>
              <thead>
                <tr><th>Name</th><th style={{ width: 100 }}></th></tr>
              </thead>
              <tbody>
                {pageItems.map((c) => (
                  <tr key={c.id}>
                    <td>{c.name}</td>
                    <td>
                      <SmallBtn danger onClick={() => handleDelete(c.id)} className="pointer">Remove</SmallBtn>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableScroll>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}

/* ============================= PROPERTIES ============================= */

const PROPERTIES_PAGE_SIZE = 10;

const EMPTY_PROPERTY = {
  id: null,
  county_id: "",
  title_number: "",
  location: "",
  tenure: "",
  approximate_area: "",
  proprietor: "",
  market_value: "",
  forced_sale_value: "",
  situation: "",
  latitude: "",
  longitude: "",
  coordinates_text: "",
  description: "",
  improvements: "",
  services: "",
  status: "available",
  user: "",
};

function PropertiesTab() {
  const [properties, setProperties] = useState([]);
  const [counties, setCounties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(EMPTY_PROPERTY);
  const [saving, setSaving] = useState(false);
  const [files, setFiles] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [pendingImages, setPendingImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(false);
  const [importing, setImporting] = useState(false);

  // --- search / filter / pagination state ---
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [countyFilter, setCountyFilter] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // debounce the title/location search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchInput.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => { setPage(1); }, [countyFilter]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [propRes, countyRes] = await Promise.all([
        NavaService.getProperties({
          status: "", // admin sees everything server allows
          q: search || undefined,
          countyId: countyFilter || undefined,
          page,
          limit: PROPERTIES_PAGE_SIZE,
        }),
        NavaService.getCounties(),
      ]);
      setProperties(propRes.data?.data || []);
      setTotal(propRes.data?.total || 0);
      setTotalPages(Math.max(1, propRes.data?.totalPages || 1));
      setCounties(countyRes.data || []);
    } catch (err) {
      setError("Failed to load properties.");
    } finally {
      setLoading(false);
    }
  }, [search, countyFilter, page]);

  useEffect(() => { load(); }, [load]);

  const startNew = () => {
    setForm(EMPTY_PROPERTY);
    setFiles([]);
    setPendingImages([]);
    setExistingImages([]);
    setShowForm(true);
  };

  const startEdit = async (p) => {
    setForm({
      id: p.id,
      county_id: p.county_id ?? "",
      title_number: p.title_number ?? "",
      location: p.location ?? "",
      tenure: p.tenure ?? "",
      approximate_area: p.approximate_area ?? "",
      user: p.user ?? "",
      proprietor: p.proprietor ?? "",
      market_value: p.market_value ?? "",
      forced_sale_value: p.forced_sale_value ?? "",
      situation: p.situation ?? "",
      latitude: p.latitude ?? "",
      longitude: p.longitude ?? "",
      coordinates_text: p.coordinates_text ?? "",
      description: p.description ?? "",
      improvements: p.improvements ?? "",
      services: p.services ?? "",
      status: p.status ?? "available",
    });
    setFiles([]);
    setPendingImages([]);
    setShowForm(true);

    setImagesLoading(true);
    try {
      const res = await NavaService.getPropertyById(p.id);
      setExistingImages(res.data?.images || []);
    } catch (err) {
      setExistingImages([]);
    } finally {
      setImagesLoading(false);
    }
  };

  const handleDeleteImage = async (imageId) => {
    const confirm = await confirmAdminAction("Remove this photo?");
    if (!confirm.isConfirmed) return;
    try {
      await NavaService.deletePropertyImage(form.id, imageId);
      setExistingImages((prev) => prev.filter((img) => img.id !== imageId));
      showAdminAlert("Photo removed.", "success");
    } catch (err) {
      showAdminAlert("Could not remove the photo.", "error");
    }
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleItemImport = async (e, startNewImport = false) => {
    const filesToImport = Array.from(e.target.files || []);
    e.target.value = "";
    if (filesToImport.length === 0) return;

    setImporting(true);
    try {
      const res = await NavaService.importPropertyItem(filesToImport);
      const imported = res.data?.fields || {};
      const importedImages = await Promise.all((res.data?.images || []).map(async (image, index) => {
        const blob = await fetch(`data:${image.type};base64,${image.data}`).then((response) => response.blob());
        return new File([blob], image.name || `item-image-${index + 1}`, { type: image.type });
      }));
      setForm((current) => ({
        ...(startNewImport ? EMPTY_PROPERTY : current),
        ...imported,
        id: startNewImport ? null : current.id,
      }));
      setFiles(importedImages);
      setPendingImages(importedImages.map((file) => ({ file, url: URL.createObjectURL(file) })));
      setExistingImages([]);
      setShowForm(true);
      showAdminAlert(
        res.data?.countyMatched
          ? "Property details imported. Review the fields before saving."
          : "Property details imported. County could not be matched, so select it before saving.",
        res.data?.countyMatched ? "success" : "warning"
      );
    } catch (err) {
      showAdminAlert(err?.response?.data?.message || "Could not import this file.", "error");
    } finally {
      setImporting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.county_id || !form.title_number.trim() || !form.location.trim()) {
      showAdminAlert("County, title number and location are required.", "warning");
      return;
    }
    setSaving(true);
    try {
      const payload = { ...form };
      delete payload.id;

      let propertyId = form.id;
      if (form.id) {
        await NavaService.updateProperty(form.id, payload);
      } else {
        const res = await NavaService.createProperty(payload);
        propertyId = res.data.id;
      }

      for (const file of files) {
        await NavaService.uploadPropertyImage(propertyId, file);
      }

      setShowForm(false);
      setFiles([]);
      setPendingImages([]);
      setExistingImages([]);
      load();
    } catch (err) {
      showAdminAlert(err?.response?.data?.message || "Could not save the property.", "error");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await confirmAdminAction("Delete this property and its photos?");
    if (!confirm.isConfirmed) return;
    try {
      await NavaService.deleteProperty(id);
      // if this was the last row on the page, step back a page rather than
      // showing an empty page
      if (properties.length === 1 && page > 1) {
        setPage((p) => p - 1);
      } else {
        load();
      }
      showAdminAlert("Property deleted.", "success");
    } catch (err) {
      showAdminAlert("Could not delete the property.", "error");
    }
  };

  return (
    <div>
      <ActionsRow className="flexSpaceCenter">
        <span className="font13" style={{ color: "#707070" }}>{total} listing(s)</span>
        <DashboardActions>
          <SmallBtn onClick={startNew} className="pointer">+ Add property</SmallBtn>
          <label>
            <SmallBtn as="span" primary className="pointer">Upload property file</SmallBtn>
            <input
              type="file"
              accept=".docx,.txt,image/*,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              multiple
              onChange={(e) => handleItemImport(e, true)}
              disabled={importing}
              hidden
            />
          </label>
        </DashboardActions>
      </ActionsRow>

      <FilterBar>
        <SearchInput
          type="text"
          placeholder="Search by title or location..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <CountySelect value={countyFilter} onChange={(e) => setCountyFilter(e.target.value)}>
          <option value="">All counties</option>
          {counties.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </CountySelect>
      </FilterBar>

      {showForm && (
        <FormCard>
          <ImportPanel>
            <div>
              <strong>Import property details</strong>
              <p>Upload a DOCX or text item file to fill the form. Review the extracted values before saving.</p>
            </div>
            <label className="pointer">
              <SmallBtn as="span" primary>{importing ? "Reading..." : "Upload item file"}</SmallBtn>
              <input type="file" accept=".docx,.txt,image/*,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple onChange={(e) => handleItemImport(e)} disabled={importing} hidden />
            </label>
          </ImportPanel>
          <Form onSubmit={handleSubmit}>
            <FormGrid>
              <Field>
                <label className="font13">County *</label>
                <select name="county_id" value={form.county_id} onChange={handleChange}>
                  <option value="">Select county</option>
                  {counties.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </select>
              </Field>

              <Field>
                <label className="font13">Status</label>
                <select name="status" value={form.status} onChange={handleChange}>
                  <option value="available">Available</option>
                  <option value="under_auction">Under auction</option>
                  <option value="sold">Sold</option>
                  <option value="withdrawn">Withdrawn</option>
                </select>
              </Field>

              <Field><label className="font13">Title number *</label><input name="title_number" value={form.title_number} onChange={handleChange} /></Field>
              <Field><label className="font13">Location *</label><input name="location" value={form.location} onChange={handleChange} /></Field>
              <Field><label className="font13">Tenure</label><input name="tenure" value={form.tenure} onChange={handleChange} placeholder="Freehold / Leasehold" /></Field>
              <Field><label className="font13">Approximate area</label><input name="approximate_area" value={form.approximate_area} onChange={handleChange} placeholder="e.g. 0.25 Ha" /></Field>
              <Field><label className="font13">User</label><input name="user" value={form.user} onChange={handleChange} /></Field>
              <Field><label className="font13">Latitude</label><input name="latitude" value={form.latitude} onChange={handleChange} /></Field>
              <Field><label className="font13">Longitude</label><input name="longitude" value={form.longitude} onChange={handleChange} /></Field>
              <Field><label className="font13">Coordinates (as surveyed)</label><input name="coordinates_text" value={form.coordinates_text} onChange={handleChange} /></Field>
            </FormGrid>

            <Field full><label className="font13">Situation</label><textarea rows="2" name="situation" value={form.situation} onChange={handleChange} /></Field>
            <Field full><label className="font13">Description</label><textarea rows="3" name="description" value={form.description} onChange={handleChange} /></Field>
            <Field full><label className="font13">Improvements</label><textarea rows="2" name="improvements" value={form.improvements} onChange={handleChange} /></Field>
            <Field full><label className="font13">Services</label><textarea rows="2" name="services" value={form.services} onChange={handleChange} placeholder="Water, electricity, road access..." /></Field>

            {form.id && (
              <Field full>
                <label className="font13">Current photos</label>
                {imagesLoading ? (
                  <span className="font13" style={{ color: "#707070" }}>Loading photos...</span>
                ) : existingImages.length === 0 ? (
                  <span className="font13" style={{ color: "#707070" }}>No photos uploaded yet.</span>
                ) : (
                  <ImageGrid>
                    {existingImages.map((img) => (
                      <ImageThumbWrap key={img.id}>
                        <img src={NavaService.getPropertyImageUrl(form.id, img.file_name)} alt="" />
                        <RemoveImageBtn type="button" onClick={() => handleDeleteImage(img.id)} title="Remove photo">×</RemoveImageBtn>
                      </ImageThumbWrap>
                    ))}
                  </ImageGrid>
                )}
              </Field>
            )}

            {pendingImages.length > 0 && (
              <Field full>
                <label className="font13">Images to save</label>
                <PendingImageGrid>
                  {pendingImages.map((image, index) => (
                    <PendingImageWrap key={`${image.file.name}-${index}`}>
                      <img src={image.url} alt={image.file.name} />
                      <RemoveImageBtn
                        type="button"
                        onClick={() => {
                          setFiles((current) => current.filter((file) => file !== image.file));
                          setPendingImages((current) => current.filter((item) => item.file !== image.file));
                          URL.revokeObjectURL(image.url);
                        }}
                        title="Remove image before saving"
                      >
                        ×
                      </RemoveImageBtn>
                    </PendingImageWrap>
                  ))}
                </PendingImageGrid>
              </Field>
            )}

            <Field full>
              <label className="font13">{form.id ? "Add more photos" : "Add photos"}</label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => {
                  const selected = Array.from(e.target.files || []);
                  setFiles((current) => [...current, ...selected]);
                  setPendingImages((current) => [
                    ...current,
                    ...selected.map((file) => ({ file, url: URL.createObjectURL(file) })),
                  ]);
                  e.target.value = "";
                }}
              />
            </Field>

            <FormActions>
              <SmallBtn type="button" onClick={() => setShowForm(false)} className="pointer">Cancel</SmallBtn>
              <SmallBtn type="submit" disabled={saving} className="pointer" primary>
                {saving ? "Saving..." : "Save property"}
              </SmallBtn>
            </FormActions>
          </Form>
        </FormCard>
      )}

      {loading ? (
        <EmptyState>Loading properties...</EmptyState>
      ) : error ? (
        <EmptyState>{error}</EmptyState>
      ) : properties.length === 0 ? (
        <EmptyState>{search || countyFilter ? "No properties match your search." : "No properties yet. Add one above."}</EmptyState>
      ) : (
        <>
          <TableScroll>
            <Table>
              <thead>
                <tr>
                  <th>Title number</th><th>Location</th><th>County</th><th>Status</th><th style={{ width: 140 }}></th>
                </tr>
              </thead>
              <tbody>
                {properties.map((p) => (
                  <tr key={p.id}>
                    <td>{p.title_number}</td>
                    <td>{p.location}</td>
                    <td>{p.county_name}</td>
                    <td><StatusPill status={p.status}>{p.status.replace("_", " ")}</StatusPill></td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <SmallBtn onClick={() => startEdit(p)} className="pointer">Edit</SmallBtn>{" "}
                      <SmallBtn danger onClick={() => handleDelete(p.id)} className="pointer">Delete</SmallBtn>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableScroll>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}

/* ============================= styles ============================= */

const Page = styled.div`
  min-height: 100vh;
  background: #f5f7fb;
  padding-bottom: 60px;
`;

const TopBar = styled.div`
  background: #ffffff;
  padding: 16px 30px;
  border-bottom: 1px solid #e6eaf0;
`;

const TitleText = styled.div`
  font-weight: 800;
  color: #13365c;
  font-size: 16px;
`;

const SubText = styled.div`
  font-size: 12px;
  color: #707070;
`;

const LogoutBtn = styled.button`
  border: 1px solid #d8dee8;
  background: transparent;
  padding: 8px 16px;
  font-weight: 700;
  color: #13365c;
  &:hover { background: #f0f2f6; }
`;

const TabBar = styled.div`
  display: flex;
  gap: 4px;
  padding: 20px 30px 0;
`;

const TabButton = styled.button`
  padding: 10px 18px;
  border: 0;
  background: ${(p) => (p.active ? "#ffffff" : "transparent")};
  color: ${(p) => (p.active ? "#5d191a" : "#13365c")};
  font-weight: 700;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  border-bottom: 3px solid ${(p) => (p.active ? "#5d191a" : "transparent")};
`;

const Content = styled.div`
  background: #ffffff;
  margin: 0 30px;
  padding: 24px;
  border-radius: 0 8px 8px 8px;
  box-shadow: 0 4px 20px rgba(19, 54, 92, 0.06);

  @media (max-width: 640px) {
    margin: 0 12px;
    padding: 16px;
  }
`;

const EmptyState = styled.div`
  padding: 40px 0;
  text-align: center;
  color: #707070;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    text-align: left;
    padding: 10px 12px;
    color: #707070;
    font-size: 12px;
    text-transform: uppercase;
    border-bottom: 2px solid #eef1f6;
  }
  td {
    padding: 12px;
    border-bottom: 1px solid #eef1f6;
    color: #13365c;
  }
  tr:hover td { background: #fafbfd; }
`;

const StatusPill = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  background: ${(p) =>
    p.status === "sold" ? "#fdecec" :
      p.status === "withdrawn" ? "#f0f0f0" :
        p.status === "under_auction" ? "#fff4e0" : "#e9f9ee"};
  color: ${(p) =>
    p.status === "sold" ? "#d63b3b" :
      p.status === "withdrawn" ? "#707070" :
        p.status === "under_auction" ? "#b76e00" : "#1a8f4c"};
`;

const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const MessageCard = styled.div`
  border: 1px solid #eef1f6;
  border-left: 4px solid ${(p) => (p.unread ? "#5d191a" : "#eef1f6")};
  border-radius: 8px;
  padding: 16px;
  background: ${(p) => (p.unread ? "#faf7ff" : "#fff")};
`;

const MessageHeader = styled.div`
  margin-bottom: 6px;
`;

const MessageSubject = styled.div`
  font-weight: 700;
  color: #13365c;
  margin-bottom: 4px;
`;

const MessageBody = styled.p`
  margin: 0 0 10px;
  color: #333;
  white-space: pre-wrap;
`;

const MessageActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ActionsRow = styled.div`
  margin-bottom: 18px;
`;

const InlineForm = styled.form`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;

  input {
    flex: 1;
    max-width: 320px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid #d8dee8;
    padding: 0 12px;
    outline: none;
  }
`;

const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  max-width: 360px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #d8dee8;
  padding: 0 12px;
  outline: none;
  font-size: 14px;

  &:focus {
    border-color: #13365c;
    box-shadow: 0 0 0 3px rgba(19, 54, 92, 0.1);
  }
`;

const CountySelect = styled.select`
  height: 38px;
  border-radius: 8px;
  border: 1px solid #d8dee8;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
  background: #fff;
  color: #13365c;
`;

const ResultCount = styled.span`
  color: #707070;
`;

const PaginationBar = styled.div`
  gap: 16px;
  margin-top: 24px;
`;

const PageNumbers = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
`;

const PageNumber = styled.button`
  min-width: 32px;
  height: 32px;
  border: 1px solid #13365c;
  border-radius: 6px;
  background: ${(p) => (p.active ? "#13365c" : "#fff")};
  color: ${(p) => (p.active ? "#fff" : "#13365c")};
  font-weight: 700;
  font-size: 13px;
`;

const PageBtn = styled.button`
  border: 1px solid #13365c;
  background: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
  color: #13365c;
  &:hover:not(:disabled) { background: #13365c; color: #fff; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const FormCard = styled.div`
  border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  background: #fafbfd;
`;

const ImportPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  margin-bottom: 20px;
  border: 1px solid #eadfe0;
  border-radius: 8px;
  background: #fff8f8;

  strong { color: #3b1718; }
  p { margin: 4px 0 0; color: #6f4b4b; font-size: 13px; }

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

const DashboardActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  label { display: inline-flex; }

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const PendingImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`;

const PendingImageWrap = styled.div`
  position: relative;
  width: 120px;
  height: 90px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border: 1px solid #eadfe0;
    border-radius: 6px;
  }
`;

const Form = styled.form``;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;

  @media (max-width: 860px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 14px;
  ${(p) => p.full && "grid-column: 1 / -1;"}

  label { margin-bottom: 6px; color: #13365c; font-weight: 700; }

  input, select, textarea {
    height: 38px;
    border-radius: 8px;
    border: 1px solid #d8dee8;
    padding: 0 12px;
    outline: none;
    font-size: 14px;
    background: #fff;
  }
  textarea {
    height: auto;
    padding: 10px 12px;
    resize: vertical;
  }
`;

const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`;

const ImageThumbWrap = styled.div`
  position: relative;
  width: 90px;
  height: 70px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    display: block;
    border: 1px solid #eef1f6;
  }
`;

const RemoveImageBtn = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 0;
  background: #d63b3b;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover { background: #b62e2e; }
`;

const SmallBtn = styled.button`
  border: 1px solid ${(p) => (p.danger ? "#f3c8c8" : p.primary ? "#5d191a" : "#d8dee8")};
  background: ${(p) => (p.danger ? "#fff5f5" : p.primary ? "#5d191a" : "#fff")};
  color: ${(p) => (p.danger ? "#d63b3b" : p.primary ? "#fff" : "#13365c")};
  padding: 7px 14px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;

  &:disabled { opacity: 0.6; cursor: not-allowed; }
  &:hover { filter: brightness(0.97); }
`;

const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;